import React, { useMemo } from 'react';
import { generatePath, Outlet, useParams } from 'react-router-dom';

import LayoutCompany from '@/components/mui/Layouts/Company';
import CompanyNavigation from '@/pages/company/components/CompanyNavigation';
import StickySubheader from '@/components/mui/Layouts/components/StickySubheader';
import ROUTES_PATH from '@/router/routesPathConfig';
import Tabs, { TabFactory } from '@/components/Tabs';
import Container from '@mui/material/Container';

const DashboardRoute: React.FC = () => {
  const { companyId = '', '*': asterisk = '' } = useParams();
  const [tab] = asterisk.split('/');

  const tabs = useMemo(
    () =>
      [
        {
          id: 'company.dashboard.vendorExpenses',
          defaultMessage: 'Vendor Expenses',
          to: generatePath(ROUTES_PATH.COMPANY_DASHBOARD_VENDOR_EXPENSES.absolute, {
            companyId,
          }),
          disabled: false,
          tabValue: 'vendor-expenses',
          betaBadge: true,
        },
      ].map(TabFactory),
    [companyId],
  );

  return (
    <LayoutCompany suppressSearch defaultDrawerOpen={false} DrawerContent={<CompanyNavigation onDocMove={() => {}} />}>
      <StickySubheader
        AppBarProps={{ sx: { bgcolor: 'common.white', borderBottom: 1, borderColor: 'divider' } }}
        BoxProps={{ mb: 0 }}
      >
        <Tabs value={tab} tabs={tabs} />
      </StickySubheader>
      <Container maxWidth={false} sx={{ flexGrow: 1, py: 2, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Container>
    </LayoutCompany>
  );
};

export default DashboardRoute;
